import { render, staticRenderFns } from "./AccountCallsTable.vue?vue&type=template&id=66727c8a&scoped=true"
import script from "./AccountCallsTable.vue?vue&type=script&lang=js"
export * from "./AccountCallsTable.vue?vue&type=script&lang=js"
import style0 from "./AccountCallsTable.vue?vue&type=style&index=0&id=66727c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66727c8a",
  null
  
)

export default component.exports